import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m3.958 9.375 4.584-4.583m-3.75 11.25h.416c.46 0 .834-.373.834-.834v-2.083a.833.833 0 0 0-.834-.833h-.416a.833.833 0 0 0-.834.833v2.084c0 .46.373.833.834.833Zm5 0h.416c.46 0 .834-.373.834-.834v-4.583a.833.833 0 0 0-.834-.833h-.416a.833.833 0 0 0-.834.833v4.584c0 .46.373.833.834.833Zm5 0h.416c.46 0 .834-.373.834-.834V4.793a.833.833 0 0 0-.834-.834h-.416a.833.833 0 0 0-.834.834V15.21c0 .46.373.833.834.833ZM9.375 6.875V3.958H6.458" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);